import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DisplayByLocationAndProvince } from '../../../../models/display/dto/display';

@Component({
  selector: 'app-single-province-location-display-list-items',
  templateUrl: './single-province-location-display-list-items.component.html',
  styleUrls: ['./single-province-location-display-list-items.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SingleProvinceLocationDisplayListItemsComponent {
  @Input() groupedRequiredDisplays: DisplayByLocationAndProvince;
  @Input() collectionIsPublished = false;
  @Input() originalRequiredDisplayIds: string[];
  @Input() updatedRequiredDisplayIds: string[];
}
